<template>
	<!-- 添加loading遮罩层 -->
	<div v-loading="isLoading" element-loading-text="加载中..." element-loading-background="rgba(255, 255, 255, 0.8)">
		<div class="contact">
			<carousel v-if="configData?.sales_banner?.length > 0" :imgList="configData?.sales_banner" class="carousel"></carousel>
			<div class="contact-page">
				<div class="contact_title">联系我们</div>
				<div class="contact_title_en">CONTACT US</div>
				<!-- 第一个卡片：销售信息 + 销售负责人 + 销售经理 -->
				<SalesInfoCard
					v-if="salesInfo.length > 0 || salesManager.length > 0 || salesManagers.length > 0 || salesManagerName.length > 0"
					:sales-info="salesInfo"
					:sales-manager="salesManager"
					:sales-managers="salesManagers"
					:salesManagerName="salesManagerName"
				/>
	
				<!-- 第二个卡片：办公室 + 人力资源 -->
				<OfficeHrCard
					v-if="officeInfo.length > 0 || hrInfo.length > 0"
					:office-info="officeInfo"
					:hr-info="hrInfo"
				/>
	
				<!-- 第三个卡片：公司地址 -->
				<AddressCard
					v-if="addressInfo?.length > 0"
					title="公司地址"
					:addressInfo="addressInfo"
				/>
	
				<!-- 暂无数据 -->
				<div v-if="salesInfo.length === 0 && salesManager.length === 0 && salesManagers.length === 0 && salesManagerName.length === 0 && officeInfo.length === 0 && hrInfo.length === 0 && addressInfo?.length === 0 && isLoading === false" class="empty_box bm bm-ver bm-ac bm-pc">
					<img src="@/assets/empty_icon.png" alt="">
					<div class="empty_text">
						暂无数据
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, watch } from 'vue'
import carousel from '@/components/carousel.vue'
import SalesInfoCard from './components/SalesInfoCard.vue'
import OfficeHrCard from './components/OfficeHrCard.vue'
import AddressCard from './components/AddressCard.vue'


// 公司地址数据
const addressInfo = ref([
  { type: 'address', text: '江苏省连云港市经济技术开发区大浦工业区金桥路16号' },
  { type: 'address', text: '江苏省连云港市经济技术开发区东方大道188号' }
])

// 销售信息数据
let salesInfo = ref([])
// 销售负责人数据
const salesManager = ref([])
const salesManagerName = ref([])
// 办公室信息数据
const officeInfo = ref([])
// 人力资源数据
const hrInfo = ref([])

// 基础配置数据
import { useConfigStore } from "@/stores/index.ts";
const store = useConfigStore()

// 使用watch监听store.configData的变化，并更新salesInfo
watch(
  () => store.configData,
  (newConfigData) => {
    if (newConfigData) {
      // 提取处理联系信息的通用函数
      const processContactInfo = (phoneData, faxData, emailData) => {
        const result = [];
        phoneData?.forEach((item) => {
          result.push({ type: 'phone', text: item });
        });
        faxData?.forEach((item) => {
          result.push({ type: 'fax', text: item });
        });
        emailData?.forEach((item) => {
          result.push({ type: 'email', text: item });
        });
        return result;
      };

      // 处理销售团队数据
      salesInfo.value = processContactInfo(
        newConfigData.salesteam_phone,
        newConfigData.salesteam_fax,
        newConfigData.salesteam_email
      );

      // 处理销售经理数据
      if (newConfigData?.salesowner_name && newConfigData.salesowner_name.length > 0) {
        salesManagerName.value = newConfigData.salesowner_name;
      }
      salesManager.value = processContactInfo(
        newConfigData.salesowner_phone,
        null,
        newConfigData.salesowner_email
      );

      // 处理办公室数据
      officeInfo.value = processContactInfo(
        newConfigData.office_phone,
        newConfigData.office_fax,
        newConfigData.office_email
      );

      // 处理人力资源数据
      hrInfo.value = processContactInfo(
        newConfigData.hr_phone,
        newConfigData.hr_fax,
        newConfigData.hr_email
      );
    }
  },
  { immediate: true, deep: true }
)

const configData = computed(() => {
	console.log(store.configData,"store.configData")
	return store.configData
})


// 添加loading状态
const isLoading = ref(false)
// 销售经理数据
import { getSalesManagers } from '@/apis'
let salesManagers = ref([])
onBeforeMount(async () => {
	isLoading.value = true
	const res = await getSalesManagers()
	if(res && res.msgCode === "100") {
		salesManagers.value = res.responseData
	}
	isLoading.value = false
})

</script>

<style lang="styl" scoped>
.contact{
	width 100%
	min-height calc(100% - 70px)
	min-width 1200px
	.carousel{
		margin-bottom 180px
	}
	.contact_title{
		font-weight: 500;
		font-size: 24px;
		color: #252525;
		line-height: 24px;
		text-align: center;
		margin-top: 73px;
	}
	.contact_title_en{
		font-size: 12px;
		color: #C1C1C1;
		line-height: 24px;
		text-align: center;
	}
	.contact-page {
		background-color: #f8f9fa;
		min-height: 100vh;
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding: 20px 200px 100px 200px;
		background-image: url('@/assets/背景_adress.png'); /* 设置背景图片 */
		background-size: cover;  /* 背景图片覆盖整个容器 */
		background-position: center;  /* 背景图片居中显示 */
		background-repeat: no-repeat;  /* 背景图片不重复 */
		padding-bottom 100px
		.empty_box{
			width: 100%;
			height: 100%;
			min-height: 50vh;
		}
	  }
	  @media (max-width: 1400px) {
		.contact-page {
		  padding: 20px 100px 100px 100px;
		}
	  }
}
</style>